import Vue from 'vue';
import { findIndex as _findIndex, map as _map } from 'lodash-es';

const state = {
  rows: [],

  roster: [],

  logs: [],
};

const mutations = {
  setRows(s, data) {
    const st = s;
    st.rows = data;
  },

  addNewGoal(s, data) {
    const st = s;
    st.rows.push(data);
  },

  updateEditedGoal(s, data) {
    const st = s;
    const index = _findIndex(st.rows, { id: data.id });
    Vue.set(st.rows, index, data);
  },

  setRoster(s, data) {
    const st = s;
    st.roster = data;
  },

  deleteGoal(s, id) {
    const st = s;
    const index = _findIndex(st.rows, { id });
    st.rows.splice(index, 1);
  },

  setLogs(s, data) {
    const st = s;
    st.logs = data;
  },

  updateRosterUser(s, data) {
    const st = s;
    const roster = _map(st.roster, 'user');
    const index = _findIndex(roster, { central_id: data.central_id });

    const record = st.roster[index];
    record.user.name = data.name;
    record.user.email = data.email;
    record.user.phone_number = data.phone_number;

    Vue.set(st.roster, index, record);
  },
};

const actions = {
  setRows({ commit }, data) {
    commit('setRows', data);
  },

  addNewGoal({ commit }, data) {
    commit('addNewGoal', data);
  },

  updateEditedGoal({ commit }, data) {
    commit('updateEditedGoal', data);
  },

  setRoster({ commit }, data) {
    commit('setRoster', data);
  },

  deleteGoal({ commit }, id) {
    commit('deleteGoal', id);
  },

  setLogs({ commit }, data) {
    commit('setLogs', data);
  },

  updateRosterUser({ commit }, data) {
    commit('updateRosterUser', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
